module.exports = __webpack_public_path__ + "img/1.6b0c6546.png";